import JaikLogo from "@/components/agency/JaikLogo";
import { useLocation, Link } from "@/lib/router-compat";
import { useEffect } from "react";
import SEOHead from "@/components/SEOHead";
import { ArrowLeft } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-agency-bg">
      <SEOHead
        title="Page Not Found | jaik"
        description="The page you are looking for does not exist. Return to jaik's homepage for contractor website design services."
        canonical="https://jaikmarketing.com"
      />
      <div className="text-center px-4">
        <Link to="/" aria-label="jaik home" className="inline-block font-heading text-2xl font-bold tracking-tight text-agency-text mb-8"><JaikLogo /></Link>
        <h1 className="mb-4 text-4xl font-bold text-agency-text">404</h1>
        <p className="mb-6 text-xl text-agency-text-muted">Oops! Page not found</p>
        <Link to="/" className="inline-flex items-center gap-2 text-agency-accent hover:text-agency-accent-glow transition-colors underline">
          <ArrowLeft className="h-4 w-4" />
          Return to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
